<div class="main-content table-page comparativo-bsc">
  <div class="container-fluid">
    <nav class="bsc-migas" aria-label="Ruta de navegación">
      <a [routerLink]="ruta.tablero" [queryParams]="queryTablero">Tablero BSC</a>
      <span aria-hidden="true">›</span>
      <span aria-current="page">Comparativo anual</span>
    </nav>

    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>{{ titulo }}</h1>
        <p>Los KPIs se emparejan por su KPI maestro, no por el texto: un cambio de redacción no los separa.</p>
      </div>
      <div class="table-page__toolbar-actions comparativo-bsc__acciones">
        <a mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
           [routerLink]="ruta.tablero" [queryParams]="queryTablero">
          <span class="material-icons" aria-hidden="true">arrow_back</span>
          Tablero
        </a>
        <!-- La tabla como se ve (con sus filtros), armada en el navegador (§10). -->
        <button mat-raised-button type="button" class="btn table-page__icon-btn table-page__icon-btn--secondary"
                *ngIf="estado === 'DATOS' && comparativo && !error && filasVisibles.length > 0"
                [disabled]="exportando || loading" [attr.aria-busy]="exportando" (click)="exportar()">
          <span class="material-icons" aria-hidden="true">{{ exportando ? "hourglass_top" : "download" }}</span>
          {{ exportando ? "Exportando…" : "Exportar tabla" }}
        </button>
        <!-- T3 en <B+1> con el área: ahí está «Crear a partir de <B>» con sus validaciones. -->
        <a mat-raised-button class="btn table-page__primary-btn" *ngIf="puedeCrearSiguiente"
           [routerLink]="ruta.planeacion" [queryParams]="queryPlaneacion">
          <span class="material-icons" aria-hidden="true">event_note</span>
          Crear {{ (comparativo?.anioB ?? 0) + 1 }} a partir de {{ comparativo?.anioB }}
        </a>
      </div>
    </section>

    <div class="bsc-franja" role="alert" *ngIf="errorExportar">
      <span class="material-icons" aria-hidden="true">error_outline</span>
      <span>{{ errorExportar }}</span>
    </div>

    <!-- ============================ Qué comparar ============================ -->
    <div class="tickets-dashboard">
      <section class="tickets-toolbar comparativo-bsc__barra" aria-label="Qué comparar">
        <div class="tickets-filter">
          <label for="bsc-comp-anio-a">Año A</label>
          <div class="tickets-select">
            <mat-icon aria-hidden="true">history</mat-icon>
            <select id="bsc-comp-anio-a" [(ngModel)]="anioA" (ngModelChange)="onAnioA()"
                    [disabled]="cargandoCatalogos || loading">
              <option *ngFor="let o of aniosA" [ngValue]="o.anio">{{ o.texto }}</option>
            </select>
          </div>
        </div>

        <div class="tickets-filter">
          <label for="bsc-comp-anio-b">Año B</label>
          <div class="tickets-select">
            <mat-icon aria-hidden="true">event</mat-icon>
            <select id="bsc-comp-anio-b" [(ngModel)]="anioB" (ngModelChange)="onAnioB()"
                    [disabled]="cargandoCatalogos || loading">
              <option *ngFor="let o of aniosB" [ngValue]="o.anio">{{ o.texto }}</option>
            </select>
          </div>
        </div>

        <div class="tickets-filter">
          <label for="bsc-comp-area">Área</label>
          <div class="tickets-select">
            <mat-icon aria-hidden="true">apartment</mat-icon>
            <select id="bsc-comp-area" [(ngModel)]="idBscArea" (ngModelChange)="onArea()"
                    [disabled]="cargandoCatalogos || loading">
              <option [ngValue]="null">Toda la empresa</option>
              <option *ngFor="let a of areas" [ngValue]="a.idBscArea">{{ a.nombre }}</option>
            </select>
          </div>
        </div>

        <div class="tickets-filter">
          <label for="bsc-comp-modo">Comparar</label>
          <div class="tickets-select">
            <mat-icon aria-hidden="true">compare_arrows</mat-icon>
            <select id="bsc-comp-modo" [(ngModel)]="modo" (ngModelChange)="onModo()"
                    [disabled]="cargandoCatalogos || loading">
              <option ngValue="corte">Mismo corte</option>
              <option ngValue="cierre">Cierre anual</option>
            </select>
          </div>
        </div>

        <div class="tickets-filter" *ngIf="modo === 'corte'">
          <label for="bsc-comp-trimestre">Trimestre</label>
          <div class="tickets-select">
            <mat-icon aria-hidden="true">date_range</mat-icon>
            <select id="bsc-comp-trimestre" [(ngModel)]="trimestre" (ngModelChange)="onTrimestre()"
                    [disabled]="cargandoCatalogos || loading">
              <option [ngValue]="null">{{ textoVigente }}</option>
              <option *ngFor="let q of trimestres" [ngValue]="q">Q{{ q }}</option>
            </select>
          </div>
        </div>

        <p class="tickets-toolbar__note comparativo-bsc__error" *ngIf="errorCatalogos" role="alert">{{ errorCatalogos }}</p>

        <div class="tickets-toolbar__meta">
          <span>{{ loading ? "Consultando…" : nombreArea }}</span>
          <strong>{{ textoCorte }}</strong>
        </div>
      </section>
    </div>

    <section class="table-page__card" *ngIf="loading || (cargandoCatalogos && !comparativo)">
      <div class="table-page__empty">
        <span class="material-icons" aria-hidden="true">hourglass_top</span>
        <h3>Consultando el comparativo</h3>
        <p>Espere un momento.</p>
      </div>
    </section>

    <section class="table-page__card" *ngIf="!loading && error">
      <div class="table-page__empty">
        <span class="material-icons" aria-hidden="true">lock_outline</span>
        <h3>No se pudo consultar el comparativo</h3>
        <p>{{ error }}</p>
      </div>
    </section>

    <ng-container *ngIf="!loading && !error && comparativo">
      <!-- Lo que hay que saber de la lectura (en vivo, sin datos, sin cierre). Con un estado vacío
           los avisos van dentro de su tarjeta: ahí son la explicación. -->
      <output class="bsc-franja comparativo-bsc__avisos" *ngIf="avisos.length > 0 && estado === 'DATOS'">
        <span class="material-icons" aria-hidden="true">info</span>
        <ul>
          <li *ngFor="let aviso of avisos">{{ aviso }}</li>
        </ul>
      </output>

      <!-- ============================ Estados vacíos ============================ -->
      <section class="table-page__card comparativo-bsc__vacio" *ngIf="estado !== 'DATOS'"
               aria-labelledby="comparativo-bsc-vacio comparativo-bsc-vacio-anio comparativo-bsc-vacio-planeacion">
        <div class="table-page__empty">
          <ng-container [ngSwitch]="estado">
            <ng-container *ngSwitchCase="'SIN_LECTURA'">
              <span class="material-icons" aria-hidden="true">sync_problem</span>
              <h3 id="comparativo-bsc-vacio">No se pudo leer el BSC de {{ anioFaltante }}</h3>
              <p>
                Una parte del año no se pudo consultar, así que no se sabe qué KPIs tiene. Los datos no se perdieron:
                vuelve a consultar en un momento.
              </p>
            </ng-container>
            <ng-container *ngSwitchCase="'SIN_ANIO'">
              <span class="material-icons" aria-hidden="true">event_busy</span>
              <h3 id="comparativo-bsc-vacio-anio">{{ anioFaltante }} no tiene datos en el BSC</h3>
              <p>
                Un año anterior entra cargando su FOR-011 en modo histórico; el año en curso y el siguiente se dan de
                alta en Parámetros. Mientras tanto, elige otro año para comparar.
              </p>
            </ng-container>
            <ng-container *ngSwitchCase="'SIN_PLANEACION'">
              <span class="material-icons" aria-hidden="true">assignment_late</span>
              <h3 id="comparativo-bsc-vacio-planeacion">{{ nombreArea }} no tiene planeación en {{ anioFaltante }}</h3>
              <p>
                Sin los KPIs de los dos años no hay con qué comparar. Los de un año anterior llegan con su FOR-011; los
                del año en curso, con la Planeación de metas o el FOR-011 del área.
              </p>
            </ng-container>
          </ng-container>

          <ul class="comparativo-bsc__vacio-avisos" *ngIf="avisos.length > 0">
            <li *ngFor="let aviso of avisos">{{ aviso }}</li>
          </ul>

          <div class="comparativo-bsc__vacio-acciones" *ngIf="estado === 'SIN_LECTURA'">
            <button mat-raised-button type="button" class="btn table-page__primary-btn" (click)="consultar()">
              <span class="material-icons" aria-hidden="true">refresh</span>
              Volver a consultar
            </button>
          </div>
          <div class="comparativo-bsc__vacio-acciones" *ngIf="estado !== 'SIN_LECTURA'">
            <a mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
               *ngIf="estado === 'SIN_ANIO' && puedeConfigurar && anioFaltante != null && anioFaltante >= anioEnCurso"
               [routerLink]="ruta.parametros">
              <span class="material-icons" aria-hidden="true">tune</span>
              Configurar {{ anioFaltante }}
            </a>
            <a mat-raised-button class="btn table-page__primary-btn" *ngIf="puedeCargarExcel" [routerLink]="ruta.cargaExcel">
              <span class="material-icons" aria-hidden="true">upload_file</span>
              Cargar Excel FOR-011
            </a>
          </div>
        </div>
      </section>

      <!-- ============================ Tiles, gráfica y los dos años ============================ -->
      <div class="tickets-dashboard comparativo-bsc__cuerpo" *ngIf="estado === 'DATOS'">
        <app-tiles-bsc [tiles]="tiles" etiqueta="Resumen del comparativo"></app-tiles-bsc>

        <section class="comparativo-bsc__graficas" aria-label="Los dos años por trimestre">
          <article class="tickets-card comparativo-bsc__grafica">
            <div class="tickets-card__header">
              <div>
                <span>{{ comparativo.anioA }} vs {{ comparativo.anioB }}</span>
                <h2>Acumulado por trimestre</h2>
              </div>
            </div>
            <app-acumulado-q-bsc [comparado]="comparativo.serieA" [real]="comparativo.serieB"
                                 [programado]="comparativo.serieProgramadoB"
                                 [nombreComparado]="'' + comparativo.anioA" [nombreReal]="'' + comparativo.anioB"
                                 [nombreProgramado]="'Programado ' + comparativo.anioB"
                                 [descripcion]="'Alcance acumulado de ' + nombreArea + ', ' + comparativo.anioA + ' contra ' + comparativo.anioB">
            </app-acumulado-q-bsc>
            <ul class="comparativo-bsc__resumen-q" aria-hidden="true">
              <li *ngFor="let r of resumenQ" [class.is-corte]="r.q === comparativo.trimestre">
                <span>Q{{ r.q }}</span>
                <strong>{{ r.texto }}</strong>
              </li>
            </ul>
            <p class="comparativo-bsc__nota">
              {{ comparativo.anioA }} / {{ comparativo.anioB }}. {{ comparativo.anioA }} se ve hasta donde llegó (su
              referencia); {{ comparativo.anioB }}, hasta el trimestre que se compara.
              {{ idBscArea == null ? "La empresa es el promedio de las áreas con planeación autorizada." :
                 "El área es el promedio de sus KPI vigentes." }}
            </p>
          </article>

          <!-- Con área: los dos años (planeación, origen, trimestre leído, objetivo). -->
          <article class="tickets-card comparativo-bsc__grafica" *ngIf="idBscArea != null"
                   aria-labelledby="comparativo-bsc-anios">
            <div class="tickets-card__header">
              <div>
                <span>{{ nombreArea }}</span>
                <h2 id="comparativo-bsc-anios">Los dos años</h2>
              </div>
            </div>
            <div class="comparativo-bsc__anios">
              <section *ngFor="let f of fichasAnio" class="comparativo-bsc__anio" [attr.aria-label]="f.rol">
                <h3><span>{{ f.rol }}</span>{{ f.anio }}</h3>
                <dl>
                  <div><dt>Planeación</dt><dd>{{ f.planeacion }}</dd></div>
                  <div><dt>Origen</dt><dd>{{ f.origen }}</dd></div>
                  <div><dt>Se lee al</dt><dd>{{ f.trimestre }}</dd></div>
                  <div>
                    <dt>Objetivo Solser</dt>
                    <dd>
                      {{ f.objetivo }}
                      <span class="table-page__status-badge bsc-badge-neutro" *ngIf="f.porOmision">umbral por defecto</span>
                    </dd>
                  </div>
                </dl>
                <p class="comparativo-bsc__anio-nota" *ngIf="f.datos">{{ f.datos }}</p>
              </section>
            </div>
          </article>

          <!-- Sin área: cada área en los dos años. -->
          <article class="tickets-card comparativo-bsc__grafica" *ngIf="idBscArea == null"
                   aria-labelledby="comparativo-bsc-areas">
            <div class="tickets-card__header">
              <div>
                <span>Toda la empresa</span>
                <h2 id="comparativo-bsc-areas">Por área</h2>
              </div>
            </div>
            <div class="table-page__table-wrap" *ngIf="filasArea.length > 0; else sinAreas">
              <table class="table-page__table comparativo-bsc__tabla-areas">
                <thead>
                  <tr>
                    <th scope="col">Área</th>
                    <th scope="col" class="comparativo-bsc__num">{{ comparativo.anioA }}</th>
                    <th scope="col" class="comparativo-bsc__num">{{ comparativo.anioB }}</th>
                    <th scope="col" class="comparativo-bsc__num">Diferencia</th>
                    <th scope="col" class="table-page__actions-head"><span class="bsc-oculto">Acciones</span></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let a of filasArea; trackBy: trackArea">
                    <td>
                      <div class="table-page__cell-stack">
                        <strong class="table-page__name">{{ a.area }}</strong>
                        <span class="table-page__subtext" *ngIf="a.nota">{{ a.nota }}</span>
                      </div>
                    </td>
                    <td class="comparativo-bsc__num">{{ a.alcanceA }}</td>
                    <td class="comparativo-bsc__num">{{ a.alcanceB }}</td>
                    <td class="comparativo-bsc__num comparativo-bsc__delta" [ngClass]="a.deltaClase">{{ a.delta }}</td>
                    <td class="comparativo-bsc__accion">
                      <button type="button" class="table-page__link comparativo-bsc__boton-enlace"
                              [attr.aria-label]="'Comparar ' + a.area" (click)="verArea(a)">Comparar</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <ng-template #sinAreas>
              <p class="comparativo-bsc__nota">Ninguna área tiene planeación en los dos años.</p>
            </ng-template>
          </article>
        </section>
      </div>

      <!-- ============================ KPI por KPI ============================ -->
      <section class="table-page__card bsc-bloque comparativo-bsc__kpis" *ngIf="estado === 'DATOS'"
               aria-labelledby="comparativo-bsc-kpis">
        <header class="bsc-bloque__encabezado bsc-bloque__encabezado--acciones">
          <div>
            <h2 id="comparativo-bsc-kpis">KPIs por KPI maestro</h2>
            <p>
              Alcance = acumulado real del KPI (columna L del FOR-011) al trimestre de cada año; la diferencia es
              {{ comparativo.anioB }} menos {{ comparativo.anioA }} en puntos. «Inicia en Qn»: el KPI aún no aplica en
              ese trimestre.
            </p>
          </div>
          <div class="comparativo-bsc__filtros" *ngIf="filas.length > 0">
            <mat-form-field appearance="outline" class="table-page__search-field comparativo-bsc__estado">
              <mat-label>Estado</mat-label>
              <select matNativeControl aria-label="Estado" [(ngModel)]="filtroEstado" (ngModelChange)="onFiltroEstado()">
                <option *ngFor="let e of filtrosEstado" [ngValue]="e">{{ textoFiltro(e) }} ({{ conteo(e) }})</option>
              </select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="table-page__search-field comparativo-bsc__buscar">
              <mat-label>Buscar KPI</mat-label>
              <input matInput aria-label="Buscar KPI" type="search" maxlength="80" [value]="filtro"
                     (input)="onFiltro($any($event.target).value)" />
            </mat-form-field>
          </div>
        </header>

        <div class="table-page__table-wrap" *ngIf="filasVisibles.length > 0; else sinKpis">
          <table class="table-page__table comparativo-bsc__tabla">
            <thead>
              <tr>
                <th scope="col" class="comparativo-bsc__col-objetivo">KPI maestro</th>
                <th scope="col" class="comparativo-bsc__num">Meta {{ comparativo.anioA }}</th>
                <th scope="col" class="comparativo-bsc__num">
                  Alcance {{ comparativo.anioA }}
                  <span class="comparativo-bsc__q" *ngIf="comparativo.trimestreA">Q{{ comparativo.trimestreA }}</span>
                </th>
                <th scope="col" class="comparativo-bsc__num">Meta {{ comparativo.anioB }}</th>
                <th scope="col" class="comparativo-bsc__num">
                  Alcance {{ comparativo.anioB }}
                  <span class="comparativo-bsc__q" *ngIf="comparativo.trimestreB">Q{{ comparativo.trimestreB }}</span>
                </th>
                <th scope="col" class="comparativo-bsc__num">Diferencia</th>
                <th scope="col" class="comparativo-bsc__col-cambio">Cambio de meta</th>
                <th scope="col">Estado</th>
                <th scope="col" class="table-page__actions-head">Ficha</th>
              </tr>
            </thead>
            <tbody *ngFor="let g of gruposVisibles; trackBy: trackGrupo">
              <tr class="comparativo-bsc__grupo" *ngIf="g.conEncabezado">
                <th scope="rowgroup" [attr.colspan]="columnas">{{ g.area }}</th>
              </tr>
              <tr *ngFor="let f of g.filas; trackBy: trackFila" [class.is-retirado]="f.valorEstado === 'RETIRADO'">
                <td class="comparativo-bsc__col-objetivo">
                  <div class="table-page__cell-stack">
                    <strong class="table-page__name comparativo-bsc__objetivo">{{ f.objetivo }}</strong>
                    <span class="table-page__subtext" *ngIf="f.indicador">{{ f.indicador }}</span>
                  </div>
                </td>
                <td class="comparativo-bsc__num" [class.is-vacio]="f.metaA === sinDato">{{ f.metaA }}</td>
                <td class="comparativo-bsc__num" [ngClass]="f.alcanceA.clase">
                  {{ f.alcanceA.texto }}
                  <span class="comparativo-bsc__subnum" *ngIf="f.alcanceA.nota">{{ f.alcanceA.nota }}</span>
                </td>
                <td class="comparativo-bsc__num" [class.is-vacio]="f.metaB === sinDato">{{ f.metaB }}</td>
                <td class="comparativo-bsc__num" [ngClass]="f.alcanceB.clase">{{ f.alcanceB.texto }}</td>
                <td class="comparativo-bsc__num comparativo-bsc__delta" [ngClass]="f.deltaClase">{{ f.delta }}</td>
                <td class="comparativo-bsc__col-cambio">
                  <div class="table-page__cell-stack">
                    <strong class="comparativo-bsc__cambio" *ngIf="f.cambioMeta">{{ f.cambioMeta }}</strong>
                    <span class="table-page__subtext" *ngIf="f.cambioPesos">{{ f.cambioPesos }}</span>
                    <span class="comparativo-bsc__motivo" *ngIf="f.motivo">{{ f.motivo }}</span>
                    <span class="table-page__subtext" *ngIf="f.quien">{{ f.quien }}</span>
                    <span class="table-page__subtext" *ngIf="f.sinCambio">{{ f.sinCambio }}</span>
                  </div>
                </td>
                <td>
                  <div class="table-page__cell-stack">
                    <span class="table-page__status-badge" *ngIf="f.estado" [ngClass]="f.estado.clase">
                      <span class="material-icons" aria-hidden="true">{{ f.estado.icono }}</span>
                      {{ f.estadoTexto }}
                    </span>
                    <span class="table-page__status-badge bsc-badge-info" *ngIf="f.pesosCambiados">
                      <span class="material-icons" aria-hidden="true">tune</span>
                      Pesos distintos
                    </span>
                  </div>
                </td>
                <td class="comparativo-bsc__accion">
                  <a class="table-page__link" *ngIf="f.idEjercicioKpiA != null" [routerLink]="[ruta.kpi, f.idEjercicioKpiA]"
                     [queryParams]="queryFicha('A')"
                     [attr.aria-label]="'Ficha de ' + f.objetivo + ' en ' + comparativo.anioA">{{ comparativo.anioA }}</a>
                  <a class="table-page__link" *ngIf="f.idEjercicioKpiB != null" [routerLink]="[ruta.kpi, f.idEjercicioKpiB]"
                     [queryParams]="queryFicha('B')"
                     [attr.aria-label]="'Ficha de ' + f.objetivo + ' en ' + comparativo.anioB">{{ comparativo.anioB }}</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <p class="comparativo-bsc__nota comparativo-bsc__nota--tabla">
          Cada cambio de meta guarda quién lo hizo, cuándo y el motivo al autorizarse la planeación del año (Planeación
          de metas).{{ hayImportados ? " Un año cargado del FOR-011 no trae el motivo." : "" }}
        </p>

        <ng-template #sinKpis>
          <div class="table-page__empty">
            <span class="material-icons" aria-hidden="true">{{ filtro || filtroEstado !== 'TODOS' ? "search_off" : "list_alt" }}</span>
            <h3>{{ filtro || filtroEstado !== "TODOS" ? "Ningún KPI coincide con el filtro" : "Las planeaciones no tienen KPIs" }}</h3>
            <p *ngIf="!filtro && filtroEstado === 'TODOS'">
              Los KPIs del año se dan de alta en Planeación de metas o llegan con el FOR-011 del área.
            </p>
          </div>
        </ng-template>
      </section>
    </ng-container>
  </div>
</div>
